const groups = (towns) => towns.reduce((a, t) => ({ ...a, [t.country]: [...(a[t.country] || []), t] }), {});

export const TownChips = ({ towns, picked, onChange, dark = false }) => {
  const toggle = (slug) => onChange(picked.includes(slug) ? picked.filter((s) => s !== slug) : [...picked, slug]);
  return (
    <div className="space-y-3" data-testid="town-chips">
      {Object.entries(groups(towns)).map(([country, list]) => (
        <div key={country}>
          <p className={`text-[10px] uppercase tracking-[0.18em] mb-1.5 ${dark ? "text-[#FAF7F2]/60" : "text-[#8C827A]"}`}>{country}</p>
          <div className="flex flex-wrap gap-2">
            {list.map((t) => {
              const on = picked.includes(t.slug);
              return (
                <button type="button" key={t.slug} onClick={() => toggle(t.slug)} data-testid={`town-chip-${t.slug}`} aria-pressed={on}
                  className={`px-3 py-1.5 text-xs border transition-colors ${on ? "bg-[#C59B27] border-[#C59B27] text-[#1C181D]" : "border-[#E2D9CC] bg-white text-[#3B1B48] hover:border-[#3B1B48]"}`}>
                  {t.town}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
